import BaseView from '../views/BaseView';
import { Object3D } from 'three';

/**
 * Find the BaseView instance to which the given Object3D belongs or throw an
 * error if none is found.
 *
 * Note that if the given object is itself an instance of BaseView, then the
 * object itself is returned. If you prefer to receive the view enclosing the
 * view you have, then call this as `getParentView(this.parent)`.
 */
export const getParentView = (obj: Object3D): BaseView => {
    let item: Object3D | null = obj;
    while(item != null) {
        if(item instanceof BaseView) {
            return item;
        } else {
            item = item.parent;
        }
    }
    throw new Error("Unable to locate parent view for Object3D");
}
